export default __webpack_public_path__ + "static/media/ringtone.569e5375.wav";